import mergeIds from "./mergeIds";
/**
 * Creates an `aria-describedby` string in a consistent order from optional
 * `aria-describedby`, `errorId`, and `hintId` props.
 */
export function describeField(props) {
  return mergeIds(props['aria-describedby'], props.errorId, props.hintId) || undefined;
}
export default describeField;